













import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Breadcrumb } from 'ant-design-vue'

@Component({
  components: {
    'a-breadcrumb': Breadcrumb,
    'a-breadcrumb-item': Breadcrumb.Item,
  },
})
export default class OrgLayout extends Vue {
  private index: number = 0
  private breadcrumbList: any[] = []

  @Watch('$route')
  onRouteChange() {
    this.initData()
  }

  isCurrent(url: string) {
    return this.$route.path === url
  }

  mounted() {
    this.initData()
  }

  touchItem(url: string) {
    if (this.isCurrent(url)) {
      return
    }
    console.log('urlxxx', url)
    this.$router.push(url)
  }

  initData() {
    let { orgId, examId, examOrgId } = this.$route.params
    console.log('examOrgIdxxxx', examOrgId)
    this.breadcrumbList = [
      {
        title: '考级点列表',
        url: '/lianwen/admin/exam/org/list',
      },
    ]
    if (orgId) {
      this.breadcrumbList.push({
        title: '考试管理',
        url: `/lianwen/admin/exam/org/detail/${orgId}`,
      })
    }

    if (examId) {
      this.breadcrumbList.push({
        title: '考试列表',
        url: `/lianwen/exam/org/detail/${orgId}/${examId}`,
      })
    }

    if (examOrgId) {
      this.breadcrumbList.push({
        title: '报名点列表',
        url: `/lianwen/exam/org/registration/${examOrgId}`,
      })
    }
  }
}
